import React from "react";

export default function LiveBetsTable({ bets, crashedAt }) {
  return (
    <div className="mt-3 w-full overflow-x-auto rounded-[20px] bg-[#171d26]">
      <table className="w-full text-base min-w-[350px]">
        <thead>
          <tr className="bg-[#202631] text-[1.02em] font-semibold text-slate-300">
            <th className="rounded-tl-[20px] p-3 text-left">User</th>
            <th className="p-3 text-right">Bet</th>
            <th className="p-3 text-center">Status</th>
            <th className="rounded-tr-[20px] p-3 text-right">Payout</th>
          </tr>
        </thead>
        <tbody>
          {bets.length === 0 && (
            <tr>
              <td
                colSpan={4}
                className="text-center py-6 text-gray-400 font-semibold"
              >
                No bets yet.
              </td>
            </tr>
          )}
          {bets.map((b, i) => (
            <tr
              key={b.userId + i}
              className="border-b border-[#242b35] last:border-b-0 hover:bg-[#1d2430]"
            >
              {/* User */}
              <td className="p-3 flex items-center gap-2 font-medium">
                {b.avatar && (
                  <img
                    src={b.avatar}
                    alt="avatar"
                    className="h-7 w-7 rounded-full object-cover"
                  />
                )}
                <span className="font-mono text-slate-200">
                  {b.username || b.userId?.slice(0, 6) || "User"}
                </span>
              </td>
              {/* Bet */}
              <td className="p-3 text-right font-bold text-white">
                ${Number(b.amount || 0).toFixed(2)}
              </td>
              {/* Status */}
              <td className="p-3 text-center font-semibold">
                {b.status === "active" && !crashedAt && (
                  <span className="animate-pulse text-emerald-300">Live</span>
                )}
                {b.status === "cashed" && (
                  <span className="text-emerald-300">
                    Cashed{" "}
                    <span className="font-bold">
                      @{b.cashedOutAt?.toFixed(2)}x
                    </span>
                  </span>
                )}
                {b.status === "crashed" && (
                  <span className="text-rose-300">Crashed</span>
                )}
              </td>
              {/* Payout */}
              <td className="p-3 text-right font-bold">
                {b.status === "cashed" ? (
                  <span className="text-emerald-300">
                    {(b.amount * b.cashedOutAt).toFixed(2)}
                  </span>
                ) : b.status === "crashed" ? (
                  <span className="text-rose-300">0</span>
                ) : (
                  ""
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
